import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "rtpl-token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const api = axios.create({ baseURL: API });

// ---- Public ----
export const fetchBootstrap = () => api.get("/bootstrap").then((r) => r.data);
export const fetchNews = () => api.get("/news").then((r) => r.data);
export const fetchProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const fetchSupportCategories = () => api.get("/support/categories").then((r) => r.data.categories);
export const submitSupport = (p) => api.post("/support", p).then((r) => r.data);

// ---- Auth ----
export const login = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me", { headers: authHeaders() }).then((r) => r.data);
export const listAdmins = () => api.get("/auth/users", { headers: authHeaders() }).then((r) => r.data);
export const createAdmin = (p) => api.post("/auth/users", p, { headers: authHeaders() }).then((r) => r.data);
export const deleteAdmin = (id) => api.delete(`/auth/users/${id}`, { headers: authHeaders() }).then((r) => r.data);

// ---- CMS CRUD ----
export const cmsList = (res) => api.get(`/cms/${res}`, { headers: authHeaders() }).then((r) => r.data);
export const cmsCreate = (res, body) => api.post(`/cms/${res}`, body, { headers: authHeaders() }).then((r) => r.data);
export const cmsUpdate = (res, id, body) => api.put(`/cms/${res}/${id}`, body, { headers: authHeaders() }).then((r) => r.data);
export const cmsDelete = (res, id) => api.delete(`/cms/${res}/${id}`, { headers: authHeaders() }).then((r) => r.data);
export const getSetting = (key) => api.get(`/cms/settings/${key}`, { headers: authHeaders() }).then((r) => r.data.value);
export const putSetting = (key, value) => api.put(`/cms/settings/${key}`, { value }, { headers: authHeaders() }).then((r) => r.data);
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/cms/upload", fd, { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } })
    .then((r) => r.data.url);
};

// ---- Submissions ----
export const listSubmissions = () => api.get("/cms/submissions", { headers: authHeaders() }).then((r) => r.data);
export const submissionStats = () => api.get("/cms/submissions/stats", { headers: authHeaders() }).then((r) => r.data);
export const updateSubmission = (id, status) =>
  api.patch(`/cms/submissions/${id}`, { status }, { headers: authHeaders() }).then((r) => r.data);

export const formatApiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};
